module.exports = {"320812001":"城南街道","320812002":"清江街道","320812003":"浦楼街道","320812004":"闸口街道","320812005":"清浦街道","320812006":"府前街道","320812007":"长西街道","320812008":"淮海街道","320812009":"长东街道","320812010":"柳树湾街道","320812011":"水渡口街道","320812012":"清河街道","320812100":"和平镇","320812101":"武墩镇","320812102":"盐河镇","320812201":"黄码乡","320812450":"宁连路"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320812.json
// module id = 897
// module chunks = 0